module.exports = __webpack_public_path__ + "static/media/wedding_help.18ba8350.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles/wedding_help.png
// module id = 827
// module chunks = 49